import styled from 'styled-components';
import SVGIcon from '../SVGIcon';
import Text from '../BuildingBlocks/Text';
import { mixins, colors } from '../css';
import AmenityList from '../AmenityList/AmenityList';

export const PropertyPaneContainer = styled.div`
  width: 26%;
  height: 100vh;
  justify-content: space-between;
  overflow-y: scroll;
  position: relative;
`;

export const CloseContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  margin-bottom: 15px;
  justify-content: flex-end;
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  z-index: 1;
  padding-right: 30px;
  margin-top: 15px;
`;

export const PaneDetailsContainer = styled.div`
  margin: 5px 20px 0px 20px;
  padding-bottom: 70px;
`;

export const AmenitySkeletonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const BookNowSkeletonContainer = styled.div`
  width: 100%;
  padding: 30px;
  margin: 15px 0;
  background-color: ${colors.colorGrey04};
`;
export const LocationTitle = styled(Text.CopyMini)`
  margin-bottom: 0;
  color: ${colors.colorGrey03};
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(22)};
`;

export const AddressTitle = styled(Text.HeadingFifth)`
  margin-top: 5px;
  font-size: ${mixins.pxToRem(12)};
  line-height: ${mixins.pxToRem(16)};
`;

export const PropertyTitle = styled(Text.HeadingFifth)`
  margin: 0 0 5px 0;
  font-weight: 600;
  font-size: ${mixins.pxToRem(18)};
`;

export const Description = styled(Text.CopyMini)`
  margin-bottom: 0;
`;

export const PaneAmenityList = styled(AmenityList)`
  margin: 10px 0;
`;

export const ImageCarouselContainer = styled.div`
  margin: -15px -20px 0 -20px;
`;

export const CloseButton = styled(SVGIcon)`
  position: absolute;
  cursor: pointer;
  z-index: 1;
`;

export const Sticky = styled.div`
  width: 100%;
  left: 0;
  z-index: 3;

  &.top {
    position: absolute;
    top: 0;
  }

  &.sticking {
    position: fixed;
    bottom: 0;
  }

  &.bottom {
    position: absolute;
    /* top set by js */
  }
`;

export const StickyStart = styled.div`
  position: relative;
`;

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: rgba(255, 255, 255, 0.5);
  z-index: 95;
  pointer-events: none;
  padding: 20px;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const AccessibilityData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 5px;
  margin-bottom: 5px;

  .bookmark {
    display: flex;
    flex-direction: row;
    padding: 5px;
    border-top: 1px solid ${colors.colorGrey04};
  }

  .banner-description {
    padding-left: 10px;
  }

  .instantProperty {
    padding-left: 5px;
    display: flex;
    flex-direction: row;
    background-color: ${colors.colorBlue05};
    margin-bottom: 5px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;
